import ResourceMonitoringPage from "@/components/pages/resource-monitoring/ResourceMonitoringPage.vue";
import BannerSettingPage from "@/components/pages/company-carousel/BannerSettingPage.vue";

export default [
  {
    path: "resources/overview",
    name: "resource.monitoring.overview",
    meta: { access: { menu: "misc", subMenu: "resource-usage" } },
    component: ResourceMonitoringPage,
  },
  {
    path: "carousels",
    name: "carousels",
    meta: { access: { menu: "misc", subMenu: "carousel-mgmt" } },
    component: BannerSettingPage,
  },
];
